import classNames from 'classnames';
import * as React from 'react';

import css from './StoresReserveColorLogo.module.scss';

interface Props {
  className?: string;
}

const StoresReserveColorLogo = ({ className }: Props) => {
  const classes = classNames(css.StoresReserveColorLogo, className);

  return (
    <svg className={classes}>
      <use xlinkHref="#logo-brand-stores" fill="url(#logo-color)" />
      <linearGradient
        id="logo-color"
        gradientUnits="userSpaceOnUse"
        x1="12.8953"
        y1="810.176"
        x2="12.8953"
        y2="841.824"
        gradientTransform="matrix(1 0 0 1 0 -810)"
      >
        <stop offset="0" stopColor="#00A2D9" />
        <stop offset="9.000000e-02" stopColor="#00AED9" />
        <stop offset="0.14" stopColor="#00B6D9" />
        <stop offset="0.18" stopColor="#0CB6D9" />
        <stop offset="0.25" stopColor="#2BB7D9" />
        <stop offset="0.34" stopColor="#5DB9D9" />
        <stop offset="0.45" stopColor="#A1BBD9" />
        <stop offset="0.54" stopColor="#D9BDD9" />
        <stop offset="0.71" stopColor="#FBB0B7" />
        <stop offset="0.77" stopColor="#FAA3AB" />
        <stop offset="0.87" stopColor="#F8808D" />
        <stop offset="0.99" stopColor="#F65163" />
      </linearGradient>
    </svg>
  );
};

export default StoresReserveColorLogo;
